export enum ShippingTypes {
  INVALID = "INVALID",
  UPS = "UPS",
  OTHER = "OTHER",
}
